module.exports = __webpack_public_path__ + "img/horizontal_7_1_8023.13f8ac64.png";